/*************************************************/
/* COMPARISON                                    */
/*************************************************/
export function subnavigation() {
    const subnavigationSelector = ".subnavigation";
    const subnavigationCollapsedClass = "subnavigation--collapsed";
    const toggleOnSelector = ".subnavigation__toggle--on";
    const toggleOffSelector = ".subnavigation__toggle--off"
    
    const init = () => {
        var onButtons = document.querySelectorAll(toggleOnSelector);
        if(onButtons) {
            onButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const card = button.closest(subnavigationSelector);
                    card.classList.remove(subnavigationCollapsedClass);

                });
            });
        }

        var offButtons = document.querySelectorAll(toggleOffSelector);
        if(offButtons) {
            offButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const card = button.closest(subnavigationSelector);
                    card.classList.add(subnavigationCollapsedClass);
                });
            });
        }
    };

    init();

}

